import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFastifyComponent } from './simple-icons-fastify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFastifyComponent ],
    exports:      [ SimpleIconsFastifyComponent ],
    bootstrap:    []
})
export class SimpleIconsFastifyModule {}
